import { render, staticRenderFns } from "./TeaserBanner.vue?vue&type=template&id=5c1b6d08&scoped=true"
import script from "./TeaserBanner.vue?vue&type=script&lang=js"
export * from "./TeaserBanner.vue?vue&type=script&lang=js"
import style0 from "./TeaserBanner.vue?vue&type=style&index=0&id=5c1b6d08&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c1b6d08",
  null
  
)

export default component.exports